import React, {useCallback, useState} from "react";
import PropTypes from "prop-types";
import {Card, CardBody, Collapse} from "reactstrap";
import classNames from "classnames";
import ChatData from "./ChatData";
import TakeDownHeader from "./TakeDownHeader";


const TakeDownDetailCard = ({ticket}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);
  return (
    <Card>
      <div className='card-body' style={{'borderLeft':'4px solid #fff','padding':'0'}}>
        <TakeDownHeader ticket={ticket} toggle={toggle} />
        <Collapse isOpen={isOpen}>
          <CardBody className={'shadow-none'}>
            <div className={"card__title"}>
              <h4 className={'bold-text'}>Messages</h4>
            </div>
            <ChatData ticket={ticket} />
          </CardBody>
        </Collapse>
      </div>
    </Card>
  )
}

TakeDownDetailCard.propTypes = {
  ticket: PropTypes.shape().isRequired
};


export default TakeDownDetailCard;
